import Call from 'iconsax-react/dist/esm/Call';
import ExportSquare from 'iconsax-react/dist/esm/ExportSquare';
import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resolveLocalizedText } from '../../../helpers/resolveLocalizedText';
import { setLang } from '../../../helpers/setLang';
import { LANDING_PAGE_PLACEHOLDERS } from 'tdr-common';
import {
	analytics,
	LINK_CLICKED_EVENT
} from '../../../helpers/analytics';
import Email from '../../../icons/email.svg';
import { getCdnImageUri } from '../../../helpers/getCDNURI';
import { RestaurantGuardOutletContext } from '../../../routes/RestaurantGuard';
import { ProceedWithLogo } from '../../logos/ProceedWithLogo';
import { BookingOptionTileWidgetVersion } from '../BookingOptionTileWidgetVersion';
import styles from './BookWithAlternativePlatform.module.scss';

const SitAnywhereIcon = () => {
	const { restaurant } = useOutletContext<RestaurantGuardOutletContext>();

	const icons = {
		phone: <Call />,
		email: <img src={Email} alt='email' />
	};

	return (
		<div className={styles.IconContainer}>
			{icons[restaurant?.settings?.alternativePlatform?.vendor] || <ExportSquare />}
		</div>
	);
};

export const BookWithAlternativePlatform = () => {
	const { i18n } = useTranslation();
	const { restaurant } = useOutletContext<RestaurantGuardOutletContext>();

	const altPlatform = restaurant.settings?.alternativePlatform?.vendor;
	const altPlatformHref = restaurant.settings?.alternativePlatform?.href;

	let href = altPlatformHref;
	if (i18n.language !== 'en') {
		href = setLang(href, i18n.language);
	}

	const contactByPhone = altPlatform === 'phone';
	const contactByEmail = altPlatform === 'email';
	const isCustom = altPlatform === 'custom';

	const hasAltPlatform = !contactByPhone && !contactByEmail && !isCustom;

	const descriptionText = {
		phone: (
			<>
				Call <span className={styles.Highlight}>{restaurant?.phoneNumber}</span> to make a standard reservation.
			</>
		),
		email: (
			<>
				Email <span className={styles.Highlight}>{restaurant.contactEmail}</span> to make a standard reservation.
			</>
		)
	};

	const handleClick = () => {
		analytics.track(LINK_CLICKED_EVENT, {
			href: href,
			purpose: 'Redirect to RMS from Landing Page',
			platform: altPlatform
		});
	};

	const title = resolveLocalizedText(restaurant.settings?.landingPage?.alternate?.title, i18n.language) || LANDING_PAGE_PLACEHOLDERS.alternate.title;
	const description = resolveLocalizedText(restaurant.settings?.landingPage?.alternate?.description, i18n.language) || descriptionText[altPlatform] || LANDING_PAGE_PLACEHOLDERS.alternate.description;
	const callToAction = resolveLocalizedText(restaurant.settings?.landingPage?.alternate?.callToAction, i18n.language) || LANDING_PAGE_PLACEHOLDERS.alternate.callToAction;

	const altBookingImageUrl = restaurant.altBookingImageUrl;
	const backgroundImage = altBookingImageUrl ? (
		<img
			src={getCdnImageUri(altBookingImageUrl)}
			srcSet={`${getCdnImageUri(altBookingImageUrl, { dpr: 2 })} 2x`}
			style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
			alt=""
		/>
	) : undefined;

	return (
		<BookingOptionTileWidgetVersion
			title={title}
			description={description}
			icon={<SitAnywhereIcon />}
			platformLogo={hasAltPlatform ? <ProceedWithLogo logo='alternate' /> : null}
			linkTo={href}
			target='_blank'
			onClick={handleClick}
			label={callToAction}
			variant={altPlatform}
			backgroundImage={backgroundImage}
		/>
	);
};
